var map = {
	"./463867761_3822636484732138_5971648607939521619_n.webp": 8813,
	"./465013255_998577028978746_1026770565999156500_n.webp": 9191,
	"./465019062_998063469030102_7880638483829218710_n.webp": 6442,
	"./468681389_18049580467990916_4374295892608116550_n.webp": 138,
	"./468688065_18049820566990916_8668296183630100481_n.webp": 4160,
	"./469254706_18050082907990916_4219382997509791904_n.webp": 6364,
	"./473525545_18054491566990916_2722583709728288483_n.webp": 6114,
	"./473561302_18054492073990916_3674461542745470002_n.webp": 4745,
	"./avental-flores.webp": 6210,
	"./avental-mulher-africana.webp": 9508,
	"./ballon-heart.webp": 7661,
	"./balon-citation.webp": 4027,
	"./bolsa-oculos-laranja.webp": 8421,
	"./bolsa-oculos-roxo.webp": 4567,
	"./brincos-feitos-a-mao.webp": 6326,
	"./caixa-guardanapos-coloridas.webp": 4103,
	"./colares-feito-a-mao.webp": 761,
	"./comment.webp": 8936,
	"./conjunto-individuais-azul-amarelo.webp": 4391,
	"./conjunto-individuais-azul-estrelas.webp": 8553,
	"./conjunto-individuais-folhas-vermelho.webp": 384,
	"./crowdfounding-dez-2025-poster.webp": 6189,
	"./cta.webp": 7930,
	"./donate-apoiar-comunidades.webp": 9729,
	"./donate-execucao-projects.webp": 5953,
	"./donate-kits-escolares.webp": 2431,
	"./donate-mensal-parcial.webp": 7319,
	"./donate-mensal-total.webp": 7251,
	"./donate-nutricao-criancas-vulneraveis.webp": 9549,
	"./donate-pequenos-almocos.webp": 510,
	"./donate-pontual-1.webp": 2651,
	"./donate-pontual-10-breakfast.webp": 3090,
	"./donate-pontual-2-kits-oral.webp": 51,
	"./donate-pontual-2.webp": 2656,
	"./donate-pontual-3.webp": 2777,
	"./donate-pontual-4.webp": 3306,
	"./donate-pontual-actividades-centro-comunitario-aquarela.webp": 5330,
	"./donate-pontual-kit-escolar-uniforme.webp": 4371,
	"./donate-pontual-placa-solar.webp": 9862,
	"./features.webp": 9332,
	"./ft.webp": 7114,
	"./header-404.webp": 6578,
	"./header-about.webp": 1216,
	"./header-contacts.webp": 6693,
	"./header-crowdfounding-2026.webp": 8372,
	"./header-donate.webp": 7863,
	"./header-partners.webp": 2546,
	"./header-project-apoio-educacional.webp": 6174,
	"./header-project-centro-comunitario-aquarela.webp": 6914,
	"./header-project-sustentabilidade-alimentar.webp": 2767,
	"./header-projects.webp": 310,
	"./header-solidarity-articles.webp": 5965,
	"./homepage-kids-pencil-hand.webp": 3878,
	"./homepage-slider-1.webp": 6216,
	"./homepage-thumbnail-breakfast.webp": 3964,
	"./homepage-thumbnail-communities.webp": 9366,
	"./homepage-thumbnail-displaced-families.webp": 820,
	"./homepage-thumbnail-educational-incentives.webp": 7371,
	"./homepage-thumbnail-home-visits.webp": 9797,
	"./homepage-thumbnail-library.webp": 8882,
	"./homepage-thumbnail-parteners.webp": 1747,
	"./homepage-thumbnail-tree-fruit.webp": 1679,
	"./imans-caras-feito-a-mao.webp": 3874,
	"./imans-feito-a-mao.webp": 7043,
	"./logo-imani.webp": 9661,
	"./logo-white.webp": 4318,
	"./partners-aquarela-adss.webp": 9065,
	"./partners-compra-solidaria.webp": 4917,
	"./partners-gentil-chiky-patas.webp": 4701,
	"./partners-mym-yo.webp": 748,
	"./partners-yoga-braga.webp": 8413,
	"./pega-cozinha-dourado.webp": 5006,
	"./pega-cozinha-laranja-azul.webp": 8087,
	"./pega-cozinha-laranja.webp": 624,
	"./pega-cozinha-verde.webp": 700,
	"./photo-2025-02-16-20-23-40.webp": 6574,
	"./photo-2025-02-16-20-32-33.webp": 8556,
	"./photo-2025-02-16-20-32-34.webp": 2453,
	"./photo-2025-02-16-20-36-35.webp": 5373,
	"./photo-2025-02-16-20-36-36.webp": 4832,
	"./photo-2025-02-16-20-36-37.webp": 2558,
	"./photo-2025-02-16-20-46-18.webp": 1316,
	"./photo-2025-02-16-21-03-25.webp": 2908,
	"./photo-2025-02-16-21-10-19.webp": 3999,
	"./porta-chaves.webp": 3295,
	"./porta-guardanapos-coloridas.webp": 5943,
	"./porta-guardanapos-vermelho.webp": 3047,
	"./projects-proj-apoio-deslocados-cabo-delgado.webp": 1830,
	"./projects-proj-apoio-educacional-IMG-20210406-WA0037.webp": 6124,
	"./projects-proj-apoio-educacional-IMG-20210619-WA0016.webp": 8476,
	"./projects-proj-apoio-educacional-IMG-20210702-WA0017.webp": 3344,
	"./projects-proj-apoio-educacional-IMG-20221015-WA0044.webp": 4169,
	"./projects-proj-apoio-educacional-IMG-20221027-WA0058.webp": 3820,
	"./projects-proj-apoio-educacional-IMG-20221027-WA0063.webp": 7598,
	"./projects-proj-apoio-educacional-IMG-20221027-WA0064.webp": 3899,
	"./projects-proj-apoio-educacional-IMG-20230210-WA0051.webp": 9140,
	"./projects-proj-apoio-educacional-IMG-20230210-WA0083.webp": 9603,
	"./projects-proj-apoio-educacional-ee4221ea-10a5-4af2-b212-2531e67d7ee6.webp": 4242,
	"./projects-proj-apoio-educacional-f133e942-9d89-4c16-b810-f986d9a12094.webp": 7767,
	"./projects-proj-apoio-educacional-kits-escolares.webp": 8067,
	"./projects-proj-apoio-educacional-pensos-higienicos-reutilizaveis.webp": 5256,
	"./projects-proj-apoio-educacional-uniformes-escolares.webp": 706,
	"./projects-proj-centro-comunitario-aquarela-kids-roundabout.webp": 7352,
	"./projects-proj-centro-comunitario-aquarela.webp": 8236,
	"./projects-proj-plantacao-fruto.webp": 941,
	"./projects-proj-sustentabilidade-alimentar-01.webp": 6845,
	"./projects-proj-sustentabilidade-alimentar-02.webp": 3200,
	"./projects-proj-sustentabilidade-alimentar-03.webp": 4353,
	"./projects-proj-sustentabilidade-alimentar-04.webp": 9253,
	"./projects-proj-sustentabilidade-alimentar-05.webp": 441,
	"./projects-proj-sustentabilidade-alimentar-06.webp": 3594,
	"./projects-thumbnail-apoio-educacional.webp": 2190,
	"./projects-thumbnail-centro-comunitario-aquarela.webp": 3439,
	"./projects-thumbnail-sustentabilidade-alimentar.webp": 8252,
	"./pub-crowdfounding-2025.webp": 6271,
	"./saco-bolsa-shop-verde.webp": 6010,
	"./saco-bolsa-shop-vermelho.webp": 2128,
	"./saco-bolsa-shop.webp": 3176,
	"./saco-ombro.webp": 992,
	"./shape.webp": 4016,
	"./shape2.webp": 3833,
	"./solidarity-articles-estatuetas.webp": 7277,
	"./solidarity-articles-lembrancas-solidarias.webp": 5295,
	"./team-01.webp": 8486,
	"./team-02.webp": 3632,
	"./team-03.webp": 6440,
	"./team-04.webp": 1437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3674;